<template>
    <div>
        <component-notifications v-if="session"/>
        <component-navbaranimated :userstorage="userstorage" v-if="session"/>
        <v-toolbar 
            class="white div-toolbar"
            dark
            fixed
            scroll-off-screen
            scroll-target="#scrolling-techniques"
            >
            <v-toolbar-title v-if="false">
                <img src="/img/logo.png" width="60" height="50"> 
            </v-toolbar-title>
            <h3 style="margin-left:5px" v-if="!session">Amta</h3>
            <v-spacer></v-spacer>
            <v-flex class="hidden-sm-and-down" md7 lg4>
                <div class="J-chat-form">
                    <input class="form-control J-chat-input" @keyup.enter="gosearchproject" v-model="searchproject" :placeholder="language === 'English'?'Enter the Project Name':'Ingrese el Nombre del Proyecto'"/>
                    <button class="btn J-chat-btn" type="submit" @click="gosearchproject">{{language === 'English'?'Search':'Buscar'}}</button>
                </div>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex class="hidden-sm-and-down" md7 lg5>
                <div class="autocomplete">
                    <input  @keyup="openlistsearch" v-model="textsearch" :placeholder="language === 'English'?'Enter the Name of the Professional or Amateur':'Ingrese el Nombre del Profesional o Aficionado'" class="form-control J-search-map w-100">
                    <ul class="autocomplete-results" v-click-outside="closelistsearchusers"  v-if="listsearchopened">
                        <li class="loading" v-if="isLoading">
                            Loading results...
                        </li>
                        <li class="autocomplete-result" v-else v-for="arrayfindedusers in arrayfindedusers" :key="arrayfindedusers.length" @click="goprofileuser(arrayfindedusers.username)">
                            <v-list-tile>
                                <v-list-tile-avatar>
                                    <img :src="arrayfindedusers.photo[0].link">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 15px; font-weight: bold">{{arrayfindedusers.fullname}}</v-list-tile-title>
                                    <v-divider></v-divider>
                                </v-list-tile-content>
                            </v-list-tile>
                        </li>
                    </ul>
                </div>
             </v-flex>
            <v-spacer></v-spacer>
            <v-btn v-if="showiconback" icon style="color:#007bff" @click="back">
                <v-icon>fas fa-arrow-left</v-icon>
            </v-btn>
           
                <v-btn icon  @click="goindex"  title="Inicio" v-if="session" style="color:#007bff">
                    <v-icon>fas fa-home</v-icon>
                </v-btn>
                <v-btn icon  @click="gohome"  title="Inicio" v-if="!session && showiconback" style="color:#007bff">
                    <v-icon>fas fa-home</v-icon>
                </v-btn>
            

            <v-menu class="hidden-md-only hidden-lg-only hidden-xl-only" :close-on-content-click="false" style="position:relative;z-index:1001">
                <v-btn icon slot="activator" style="color:#007bff">
                    <v-icon>fas fa-search-plus</v-icon>
                </v-btn>
                <v-list>
                    <v-list>
                        <v-list-tile>
                            <div class="J-chat-form2">
                                <input class="form-control J-chat-input2" @keyup.enter="gosearchproject" v-model="searchproject" :placeholder="language === 'English'?'Search Projects':'Busca Proyectos'"/>
                                <button class="btn J-chat-btn2" type="submit" @click="gosearchproject"><i class="fas fa-search"></i></button>
                            </div>
                        </v-list-tile>   
                    </v-list>
                </v-list>
            </v-menu>
            <v-menu class="hidden-md-only hidden-lg-only hidden-xl-only" :close-on-content-click="false" style="position:relative;z-index:1001">
                <v-btn icon slot="activator" style="color:#007bff">
                    <v-icon>fas fa-search</v-icon>
                </v-btn>
                <v-list>
                    <v-list>
                        <v-list-tile>
                            <input v-model="textsearch" @keyup="openlistsearch"  class="J-form-input" :placeholder="language === 'English'?'Search Profesionals or Amateurs':'Busca Profesionales o Aficionados'">
                        </v-list-tile>   
                    </v-list>
                    <v-list v-click-outside="closelistsearchuser" v-if="listsearchopened && !arrayfindedusers.length <=0" style="background: white;margin-top:-10px;">
                        <v-list-tile  v-for="arrayfindedusers in arrayfindedusers" :key="arrayfindedusers.length" @click="goprofileuser(arrayfindedusers.username)"  style="cursor:pointer;padding-bottom:10px; width:100%">
                            <v-list-tile-avatar>
                                <img :src="arrayfindedusers.photo[0].link">
                            </v-list-tile-avatar>
                            <v-list-tile-content   style="height: 160px; margin-top: 40px">
                                <v-list-tile-title style="margin-top: 5px; font-size: 15px; font-weight: bold">{{arrayfindedusers.fullname}}</v-list-tile-title>
                                <v-divider></v-divider>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-list>
            </v-menu>
            <!--v-btn v-if="session" icon style="color:#007bff" @click="goprofileuser(userstorage.username)">
                <v-icon>fas fa-user</v-icon>
            </v-btn>
            <v-btn v-if="session" icon style="color:#007bff" @click="gotoprojects">
                <v-icon>fas fa-folder</v-icon>
            </v-btn-->
            <v-btn v-if="session" icon  @click="showandhide" style="color:#007bff">
                    <v-icon>fas fa-bell</v-icon>
                    <span v-if="datanovisible >0"   class="campana">{{datanovisible}}</span>
            </v-btn>
            <v-menu v-if="!session">
                <v-btn icon slot="activator" style="color:#007bff">
                    <v-icon>fas fa-globe</v-icon>
                </v-btn> 
                <v-list>
                    <v-list-tile @click="changelanguage(chossinglanguage)" v-for="chossinglanguage in chossinglanguage" :key="chossinglanguage.length">
                        <label>{{chossinglanguage.language}}</label>
                    </v-list-tile>
                </v-list>
            </v-menu>
            
            <v-btn icon v-if="session" style="color:#007bff" @click="showmenu">
                    <v-icon>fas fa-bars</v-icon>
            </v-btn> 
            <button v-if="!session && !showiconback" type="button"  class="btn btn-primary" @click="getstarted">{{language === 'English'?'Log in':'Iniciar Sesión'}}</button>
            <!--v-menu v-if="session">
                <v-btn icon slot="activator" style="color:#007bff" @click="showmenu">
                    <v-icon>fas fa-plus</v-icon>
                </v-btn> 
                <v-list>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title @click="logout" class="fas fa-user-alt-slash" style="cursor:pointer"> {{language === 'English'?'Log out':'Cerrar Sesión'}}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>  
                </v-list>
            </v-menu-->
            
            <!--v-menu>
                <v-btn icon slot="activator" style="color:#007bff">
                    <v-icon>fas fa-globe</v-icon>
                </v-btn> 
                <v-list>
                    <v-list-tile @click="changelanguage(chossinglanguage)" v-for="chossinglanguage in chossinglanguage" :key="chossinglanguage.length">
                        <label>{{chossinglanguage.language}}</label>
                    </v-list-tile>
                </v-list>
            </v-menu-->
            <!--v-btn v-if="session" icon style="color:#007bff" @click="opentutorial">
                <v-icon>far fa-file-video</v-icon>
            </v-btn-->
        </v-toolbar>
        <!-- Navigation -->
    <!--nav class="navbar navbar-light bg-light" style="position:fixed;z-index:10">
        <div class="container">
            <a class="navbar-brand">Start Bootstrap</a>
            <v-btn icon>
                <v-icon>fas fa-search</v-icon>
            </v-btn>
            <v-btn icon>
                <v-icon>fas fa-search</v-icon>
            </v-btn>
            <a v-if="!session" class="btn btn-primary" @click="goLogin" style="color:white">Iniciar Sesión</a>
            <a v-else class="btn btn-primary" @click="logout" style="color:white">Cerrar Sesión</a>
        </div>
    </nav-->
    </div>
</template>
<script>
// Import the EventBus we just created.
import ClickOutside from 'vue-click-outside'

import { EventBus } from '../../../helpers/eventbus/event-bus.js'
import initVue from '../../../helpers/initVue'

import env from '../../../config/env.example'

import notifications from '@/components/Templates/Views/notifications'

import { UsersService } from "@/services"

import Navbaranimated from './Navbaranimated'



import {
    mapGetters
} from 'vuex'

export default {
    directives: {
        ClickOutside
    },
    computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
    }),
    data(){
        return{
            searchproject:'',
            identity: null,
            session: false,
            token: null,
            language:'',
            chossinglanguage:[
                {
                    language: 'English'
                },
                {
                    language: 'Español'
                }
            ],
            dialog: false,
            contentlaundry: false,
            contenttaxis: false,
            userstorage: {},
            nameicon: '',
            textsearch : '',
            listsearchopened: false,
            arrayfindedusers: [],
            wordstosearchcompanies: '',
            showiconback:false,
            datanovisible:0
        }
    },

    components:{
        'component-notifications':notifications,
        'component-navbaranimated':Navbaranimated
    },  
    created(){
        var checked=localStorage.getItem('datanovisible')
        //console.log(checked)
        if(checked!=null){
            this.datanovisible = this.datanovisible +  parseInt(checked)      
        }else{
            this.datanovisible = 0
        }
    },
    mounted(){
        
        if(this.$route.path === '/'){
            this.showiconback = false
        }else{
            this.showiconback = true
        }
        this.getidentity()
        this.getuser()
        if(this.session){
            window.addEventListener('mouseup', function(event){
                var box = document.getElementById('notModal');
                if(event.target.className!=''){
                    if(event.target.id != 'notModal' && event.target.parentNode.id != 'notModal' && !event.target.parentNode.className.includes('bodyNot') && !event.target.className.includes('bodyNot') &&  !event.target.parentNode.className.includes('a-dropdown-item') && !event.target.className.includes('a-dropdown-item')){
                        box.style.display = 'none';
                    }
                }
                else{
                    box.style.display = 'none';
                }
            }) 
        }
        EventBus.$on('getuser', () =>{
            this.getuser()
        })
        EventBus.$on('senddatanovisible',(datanovisible)=>{
            this.datanovisible = datanovisible
            localStorage.setItem('datanovisible',this.datanovisible)
        })
        EventBus.$on('changelanguage',()=>{
            //console.log(this.$route)
            
            if(this.$route.name === 'Profileuser' || !this.session || this.$route.name ==='fileprojects' ||this.$route.name ==='Comentarios' || this.$route.name === 'SearchProjects'){
                window.location = window.location.href
            }else{
                let choosedlanguage = JSON.parse(localStorage.getItem('language'))
                this.language = choosedlanguage.language
            }
            
            //console.log(this.language)
            //console.log(choosedlanguage)
        })
        let choosedlanguage = JSON.parse(localStorage.getItem('language'))
        if(choosedlanguage){
            this.language = choosedlanguage.language
        }
        EventBus.$on('logout',()=>{
            this.logout()
        })

        

    },
    methods: {
        showmenu(){
            EventBus.$emit('showmenu')
        },
        gohome(){
            this.$router.push('/')
            this.showiconback = false
        },
        goindex(){
            window.location = `${env.host}${this.userstorage.username}`
        },
        getstarted(){
          EventBus.$emit('opentutorialwrited')
        },
        makeelementvisible(){
            this.datanovisible = 0
            localStorage.removeItem('datanovisible')
            EventBus.$emit('elementvisible')
        },
        closemodal(){
            var box = document.getElementById('notModal');
            box.style.display="none"
        },
        showandhide(){
            var box = document.getElementById('notModal');
            if(box.style.display == "none"){
                box.style.display="block"
            }else{
                box.style.display="none"
            }
            this.makeelementvisible()
        },     
        opentutorial(){
            EventBus.$emit('opentutorial')
        },
        changelanguage(language){
            localStorage.setItem('language',JSON.stringify(language))
            EventBus.$emit('changelanguage')
        },
        gosearchproject(){
            let wordssearchprojectisempty = this.searchproject === ''
            if(!wordssearchprojectisempty){
                window.location = `${env.host}searchproject/${this.searchproject}`
            }
        },
        back(){
            this.$router.back()
        },
        gotoprojects(){
            this.$router.push('/projects')
        },
        gocart:function(){
            this.$router.push('/cart');
        },
        goprofileuser(username){
            this.listsearchopened = false
            window.location = `${env.host}${username}`
        },

        getuser(){
            localStorage.removeItem('user')
            var checked=localStorage.getItem('user');
            //console.log(checked)
            if(checked!=null){
                this.userstorage = JSON.parse(checked);
                //console.log(JSON.parse(checked))   
                return;             
            }
            if(this.session){
                let query = {

                }
              UsersService.getdatauser(query).then(res=>{
                localStorage.setItem('user',JSON.stringify(res.data.user))
                this.userstorage = res.data.user
                if(this.$route.path === '/'){
                    window.location = `${env.host}${this.userstorage.username}`
                    //this.goprofileuser(this.userstorage.username)
                }
              })
                /*
                this.axios.get(`users/getuser/${this.identity._id}/${this.token}`)
                .then((res) => {
                    localStorage.setItem('user',JSON.stringify(res.data.user))
                    this.userstorage = res.data.user
                    if(this.$route.path === '/'){
                        this.goprofileuser(this.userstorage.username)
                    }
                })*/
            }
        },
        /*******************************************************
 * * Obteniendo la identidad para validar el token
 *******************************************************/
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)
            
        },

        /*******************************************************
 * * Cerrar Sesión
 *******************************************************/
        closelistsearchuser(){
            this.listsearchopened = false
        },

        logout(){
          this.axios.get('user/logout/'+this.identity._id)
          this.userstorage = {}
          this.identity = null
          this.token = null
          localStorage.removeItem('iden')
          localStorage.removeItem('user')
          localStorage.removeItem('tok')
          localStorage.clear
          this.$store.dispatch('saveIdentity', null)
          this.$store.dispatch('saveToken', null)
          window.location = '/'

        },

        goLogin(){
            EventBus.$emit('goLogin')
        },
        
        seeperfil(){
            EventBus.$emit('opendialog')
        },

        
        
        closemodal(){
            this.dialog = false
        },

        openmodalcarbuy(){
            EventBus.$emit('openmodalcarbuy')  
        },

        dialogregistercompanyopen(){
          EventBus.$emit('companyregister')  
        },

        gofavorites(){
            EventBus.$emit('openmodalfavoritescompany')
        },
        
        openlistsearch(){
            let textempty = this.textsearch === ''
            if(textempty){
                this.listsearchopened = false
            }else{
                let query = {
                    textsearch: this.textsearch
                }

                UsersService.searchusers(query).then(res=>{
                  //console.log(res.data.company)
                  this.arrayfindedusers = res.data.users
                  this.listsearchopened = true
                  //console.log(this.arrayfindedusers)
                
                })
                /******************* * Login Errado!!!!********************************/
                .catch(() => {
                  this.listsearchopened = false
                })
            }
        }


    }
}
</script>

<style lang="scss" scoped>
    .div-toolbar{
        z-index:100
    }
    .J-color-primary{
        // background: #6366D6 !important;
        background: #11679a !important;
         
    }
    .J-form-input{
        background-color: #fff;
        color: #000;
        border-radius: 5px;
        padding: 8px;
        margin: 10px 0 10px 0;
        width: 100%;
    }

    .inputsearch{
        margin-top: 80px;
    }
    .J-chat-form{
		position: relative;
		.J-chat-input{
			height: 35px;
			padding: 10px;
		}
		.J-chat-btn{
			position:  absolute;
			top: 0;
			right: 0;
			width:65px;
			outline: none;
			height: 35px;
			background-color: #007bff;
			color: #fff;
			&:focus{
				box-shadow: none;
			}
		}
    }
    .J-chat-form2{
		position: relative;
		.J-chat-input2{
			height: 35px;
			padding: 10px;
		}
		.J-chat-btn2{
			position:  absolute;
			top: 0;
			right: 0;
			width:45px;
			outline: none;
			height: 35px;
			background-color: #007bff;
			color: #fff;
			&:focus{
				box-shadow: none;
			}
        }
    }
    @media (max-width: 300px) {
        .div-toolbar {
            overflow:auto
        }
    }
</style>
